import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Plus, Search, Phone } from "lucide-react";
import { api, fmtDate } from "@/lib/api";
import { PageHeader, Panel, GoldButton, Empty, inputCls } from "@/components/common";

export default function Clients() {
  const [q, setQ] = useState("");
  const [items, setItems] = useState(null);
  const nav = useNavigate();

  useEffect(() => {
    const t = setTimeout(() => api.get("/clients", { params: { q } }).then((r) => setItems(r.data)), 250);
    return () => clearTimeout(t);
  }, [q]);

  return (
    <div data-testid="clients-page">
      <PageHeader overline="Archivio" title="Clienti">
        <GoldButton onClick={() => nav("/clienti/nuovo")} data-testid="new-client-button"><Plus className="h-4 w-4" /> Nuovo cliente</GoldButton>
      </PageHeader>
      <div className="relative mb-6 max-w-md">
        <Search className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-[#9E958A]" />
        <input className={`${inputCls} pl-9 bg-white`} placeholder="Cerca per nome, telefono o email" value={q} onChange={(e) => setQ(e.target.value)} data-testid="clients-search-input" />
      </div>
      {items && items.length === 0 && <Empty testId="clients-empty">Nessun cliente trovato. Inserisci il primo cliente con il pulsante in alto.</Empty>}
      {items && items.length > 0 && (
        <Panel className="overflow-hidden">
          <div className="hidden md:grid grid-cols-12 gap-4 border-b border-[#E8E1D7] bg-[#F6F1EA] px-6 py-3 text-xs uppercase tracking-[0.14em] text-[#6E675F]">
            <div className="col-span-4">Nome</div><div className="col-span-3">Contatti</div><div className="col-span-3">Operatore di riferimento</div><div className="col-span-2">Inserito il</div>
          </div>
          <ul className="divide-y divide-[#E8E1D7]">
            {items.map((c) => (
              <li key={c.id}>
                <Link to={`/clienti/${c.id}`} data-testid={`client-row-${c.id}`} className="grid grid-cols-1 md:grid-cols-12 gap-1 md:gap-4 px-6 py-4 transition-colors hover:bg-[#FDFBF7]">
                  <div className="md:col-span-4 flex items-center gap-3">
                    <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-[#121212] font-serif text-[#E9CF86] border border-[#C5A059]">{c.first_name[0]}{c.last_name[0]}</div>
                    <div className="font-medium text-[#121212]">{c.last_name} {c.first_name}</div>
                  </div>
                  <div className="md:col-span-3 text-sm text-[#6E675F] flex items-center gap-1.5 md:pl-0 pl-13">{c.phone && <Phone className="h-3.5 w-3.5" />}{c.phone || c.email || "—"}</div>
                  <div className="md:col-span-3 text-sm text-[#6E675F]">{c.operator_name || "—"}</div>
                  <div className="md:col-span-2 text-sm text-[#9E958A]">{fmtDate(c.created_at)}</div>
                </Link>
              </li>
            ))}
          </ul>
        </Panel>
      )}
    </div>
  );
}
